<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div class="back-button-bg" @click="gotoBack">
          <ion-icon mode="ios" name="arrow-back" size="large" class="white"></ion-icon>
        </div>
        <p class="page-title">Filtrar receitas</p>
      </ion-grid>
      <div class="edit-block-max-height mt-5">
        <div class="edit-block-padding">
          <label>Receitas com um ingrediente específico?</label>
          <ais-instant-search
            class="mt-3"
            :search-client="searchClient"
            index-name="IngredientsIndex"
          >
            <ais-search-box class="mb-3" ref="searchBox" />
            <ais-hits
              :class-names="{
              'ais-Hits-item': 'MyCustomHitsItem'
            }"
            >
              <div
                slot="item"
                slot-scope="{ item }"
                class="cursor-pointer search-hit"
                @click="selectIngredient(item)"
              >
                <p class="mt-0 mb-1 ion-text-uppercase grey text-sm">Sugestão</p>
                <p class="mt-0 mb-0 bold text-lg">{{ item.namePT }}</p>
              </div>
            </ais-hits>
            <ais-configure :hits-per-page.camel="1" />
          </ais-instant-search>
          <div class="preference-list mt-3 mb-5">
            <div v-for="preference in preferences" :key="preference.id" class="d-inline-block">
              <ion-chip>
                <ion-label>{{ preference.namePT }}</ion-label>
                <ion-icon
                  mode="ios"
                  name="close-circle"
                  class="cursor-pointer"
                  @click="removeIngredient(preference.id)"
                ></ion-icon>
              </ion-chip>
            </div>
          </div>
        </div>

        <label class="edit-block-padding">Receitas para qual refeição?</label>
        <ion-item class="form-item large-square mb-4 mt-1" lines="none">
          <ion-select
            okText="Ok"
            cancelText="Cancelar"
            class="padding-input"
            :value="filters.meal"
            @ionChange="changeMeal($event.target.value)"
          >
            <ion-select-option value="all">Todas</ion-select-option>
            <ion-select-option value="breakfast">Café-da-manhã</ion-select-option>
            <ion-select-option value="morningSnack">Lanche da manhã</ion-select-option>
            <ion-select-option value="lunch">Almoço</ion-select-option>
            <ion-select-option value="afternoonSnack">Lanche da tarde</ion-select-option>
            <ion-select-option value="dinner">Jantar</ion-select-option>
            <ion-select-option value="supper">Ceia</ion-select-option>
          </ion-select>
        </ion-item>

        <label class="edit-block-padding">Alguma restrição alimentar?</label>
        <ion-item class="form-item large-square mb-4 mt-1" lines="none">
          <ion-select
            okText="Ok"
            cancelText="Cancelar"
            class="padding-input"
            multiple="true"
            placeholder="Nenhuma"
            @ionChange="changeRestrictions($event.target.value)"
          >
            <ion-select-option value="vegan">Vegano</ion-select-option>
            <ion-select-option value="vegetarian">Vegetariano</ion-select-option>
            <ion-select-option value="lactoseFree">Sem lactose</ion-select-option>
            <ion-select-option value="glutenFree">Sem glúten</ion-select-option>
          </ion-select>
        </ion-item>
        <div class="edit-block-padding">
          <ion-button
            expand="block"
            mode="ios"
            shape="round"
            class="confirm-filter-button"
            @click="saveFilter"
          >
            <ion-icon mode="ios" name="checkmark" class="white" size="large"></ion-icon>
          </ion-button>
        </div>
      </div>
    </ion-content>
  </ion-app>
</template>

<script>
// algolia
import algoliasearch from "algoliasearch/lite";
import "instantsearch.css/themes/algolia-min.css";
// firebase
import db from "@/firebase/init";
import firebase from "firebase";
import functions from "firebase/functions";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// rfdc
const clone = require("rfdc")();
// store
import store from "../../utils/store.js";
// component
export default {
  name: "FilterRecipes",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: true,
      fullPage: true,
      user: store.state.user,
      filters: store.state.filters,
      meal: {
        breakfast: false
      },
      preferences: store.state.filters.preferences,
      searchClient: algoliasearch(
        "7SV0OCMMIQ",
        "7ffa9318b3c6b0d8b93fb27f11935ead"
      )
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    gotoBack() {
      this.$router.go(-1);
    },
    changeMeal(meal) {
      this.filters.meal = meal;
    },
    changeRestrictions(restrictions) {
      this.filters.restrictions = restrictions;
    },
    async saveFilter() {
      const preferencesRaw = this.preferences;
      let preferences = [];
      for (let i = 0; i < preferencesRaw.length; i++) {
        const obj = {
          id: preferencesRaw[i].id,
          namePT: preferencesRaw[i].namePT
        };
        preferences.push(obj);
      }
      this.filters.preferences = preferences;
      store.state.filters = this.filters;
      this.$router.push({
        name: "Recipe Book"
      });
    },
    selectIngredient(item) {
      const preferences = this.preferences;
      let idList = [];
      for (let i = 0; i < preferences.length; i++) {
        idList.push(preferences[i].id);
      }
      if (!idList.includes(item.objectID)) {
        const itemObj = {
          id: item.objectID,
          namePT: item.namePT
        };
        preferences.push(itemObj);
      }
      this.preferences = preferences;
    },
    removeIngredient(id) {
      const preferences = this.preferences;
      for (let i = 0; i < preferences.length; i++) {
        if (preferences[i].id === id) {
          preferences.splice(i, 1);
        }
      }
      this.preferences = preferences;
    }
  },
  async created() {
    const instance = this;
    store.state.filters.restrictions = [];
    instance.filters.restrictions = [];
    setTimeout(() => {
      instance.isLoading = false;
    }, 500);
  }
};
</script>

<style scoped>
ion-content {
  --background: var(--ion-color-grey) !important;
}
ion-select {
  max-width: 100% !important;
}
.padding-input {
  --padding-start: 8vw;
}
</style>
